module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "specialAdd"
  }, [_c('el-breadcrumb', {
    staticClass: "bread-nav",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("商业专题")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("添加专题")])], 1), _vm._v(" "), _c('div', {
    staticClass: "special-add-box"
  }, [_c('el-form', {
    ref: "addSpecialForm",
    staticClass: "addSpecialForm",
    attrs: {
      "model": _vm.addSpecialForm,
      "rules": _vm.validateRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "specialName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写专题标题"
    },
    model: {
      value: (_vm.addSpecialForm.specialName),
      callback: function($$v) {
        _vm.addSpecialForm.specialName = $$v
      },
      expression: "addSpecialForm.specialName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属大区",
      "prop": "company"
    }
  }, [_c('el-select', {
    staticClass: "selectForm",
    attrs: {
      "placeholder": "请选择大区"
    },
    model: {
      value: (_vm.addSpecialForm.company),
      callback: function($$v) {
        _vm.addSpecialForm.company = $$v
      },
      expression: "addSpecialForm.company"
    }
  }, _vm._l((_vm.companyList), function(companyItem) {
    return _c('el-option', {
      key: companyItem,
      attrs: {
        "label": companyItem,
        "value": companyItem
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "头图",
      "prop": "specialImage"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写专题头图"
    },
    model: {
      value: (_vm.addSpecialForm.specialImage),
      callback: function($$v) {
        _vm.addSpecialForm.specialImage = $$v
      },
      expression: "addSpecialForm.specialImage"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "概述",
      "prop": "specialContent"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请填写专题概述"
    },
    model: {
      value: (_vm.addSpecialForm.specialContent),
      callback: function($$v) {
        _vm.addSpecialForm.specialContent = $$v
      },
      expression: "addSpecialForm.specialContent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "项目经理",
      "prop": "createUser"
    }
  }, [_c('el-select', {
    staticClass: "selectForm",
    attrs: {
      "placeholder": "请选择项目经理"
    },
    model: {
      value: (_vm.addSpecialForm.createUser),
      callback: function($$v) {
        _vm.addSpecialForm.createUser = $$v
      },
      expression: "addSpecialForm.createUser"
    }
  }, _vm._l((_vm.userList), function(userItem) {
    return _c('el-option', {
      key: userItem.userId,
      attrs: {
        "label": userItem.userName,
        "value": userItem.userId
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addSpecial('addSpecialForm')
      }
    }
  }, [_vm._v("立即创建")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.clearSpecialData()
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "special-preview-box"
  }, [(_vm.addSpecialForm.specialImage !== null && _vm.addSpecialForm.specialImage !== '') ? _c('div', {
    staticClass: "header-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.addSpecialForm.specialImage,
      "alt": "一点资讯"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.addSpecialForm.specialContent !== null && _vm.addSpecialForm.specialContent !== '') ? _c('div', {
    staticClass: "description"
  }, [_c('div', {
    staticClass: "desc-icon"
  }, [_vm._v("概述")]), _vm._v(" "), _c('span', {
    staticClass: "desc-content"
  }, [_vm._v(_vm._s(_vm.addSpecialForm.specialContent))])]) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-50cba7e3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/business/Add.vue
// module id = 766
// module chunks = 1